import React, { useEffect } from 'react';
import { LoadingIndicator, Text } from 'library';
import { Checkbox, Grid } from '@material-ui/core';
import { client } from 'shared';
import { FloridaTrainingFields, trainingFields, FloridaTranscriptVerifyProps } from '../models';

export default function FloridaTranscriptVerify({
    checkboxStates,
    setCheckboxStates,
    activeWorker,
}: FloridaTranscriptVerifyProps) {
    function refreshState() {
        client(`api/fl-training-info-collect/get-trainings-completion-state/?worker=${activeWorker}`).then(
            setCheckboxStates,
        );
    }

    useEffect(refreshState, [activeWorker]);

    const handleCheckboxChange = (fieldName: keyof FloridaTrainingFields, isChecked: boolean) => {
        setCheckboxStates((state: FloridaTrainingFields) => {
            return { ...state, [fieldName]: isChecked };
        });
    };

    return (
        <Grid container>
            <Grid container item direction="column" alignItems="center">
                {Object.keys(checkboxStates).length > 0 ? (
                    trainingFields.map((fieldName) => {
                        const value = checkboxStates[fieldName as keyof typeof checkboxStates];
                        return (
                            <Grid container item key={fieldName} direction="row" alignItems="center">
                                <Checkbox
                                    id={fieldName}
                                    checked={value}
                                    onChange={() => handleCheckboxChange(fieldName, !value)}
                                />
                                <Text variant="body2">Verified completed {fieldName}</Text>
                            </Grid>
                        );
                    })
                ) : (
                    <LoadingIndicator />
                )}
            </Grid>
        </Grid>
    );
}
